import { ReactElement } from 'react';
import { EIconSize } from 'utils/constants/app/ui';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { Skeleton } from 'newcomponents/UI/Skeleton';

export const GameSingleItemSkeletonMobile = ({
  expanded
}: {
  expanded?: boolean;
}): ReactElement => {
  return (
    <div
      style={{
        backgroundColor: 'var(--v3-black-0)',
        borderRadius: 4,
        marginBottom: 4
      }}
    >
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          padding: '8px 8px 7px',
          borderBottom: '1px solid var(--v3-black-6)'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
          }}
        >
          <Skeleton.Avatar
            size={EIconSize._24}
            active
            style={{
              marginLeft: SpringConfigs.IS_RTL ? '8px' : '0'
            }}
          />
          <Skeleton
            title={{
              style: { width: 150, margin: '0 0 0 8px', height: 12 }
            }}
            paragraph={false}
            active
          />
        </div>
      </div>
      {expanded && <GameSingleItemDetailsSkeletonMobile />}
    </div>
  );
};

export const GameSingleItemDetailsSkeletonMobile = (): ReactElement => {
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: '0 8px',
        borderTop: '2px solid var(--v3-black-6)',
        background: 'var(--v3-black-0)'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', height: '28px' }}>
        <Skeleton
          title={{
            style: { width: 100, margin: '0', height: 8 }
          }}
          paragraph={false}
          active
        />
        <Skeleton
          title={{
            style: {
              width: 50,
              margin: '0',
              height: 8,
              float: SpringConfigs.IS_RTL ? 'left' : 'right'
            }
          }}
          paragraph={false}
          active
        />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '73px',
          justifyContent: 'space-around',
          borderTop: '1px solid var(--v3-black-6)'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Skeleton.Avatar
              size={EIconSize._24}
              active
              style={{
                marginTop: '2px',
                marginLeft: SpringConfigs.IS_RTL ? '8px' : '0'
              }}
            />
            <Skeleton
              title={{
                style: { width: 100, margin: '0 0 0 8px', height: 12 }
              }}
              paragraph={false}
              active
            />
          </div>
          <Skeleton
            title={{
              style: {
                width: 16,
                margin: '0',
                height: 16,
                display: 'flex',
                float: SpringConfigs.IS_RTL ? 'left' : 'right'
              }
            }}
            paragraph={false}
            active
          />
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Skeleton.Avatar
              size={EIconSize._24}
              active
              style={{
                marginTop: '2px',
                marginLeft: SpringConfigs.IS_RTL ? '8px' : '0'
              }}
            />
            <Skeleton
              title={{
                style: { width: 100, margin: '0 0 0 8px', height: 12 }
              }}
              paragraph={false}
              active
            />
          </div>
          <Skeleton
            title={{
              style: {
                width: 16,
                margin: '0',
                height: 16,
                display: 'flex',
                float: SpringConfigs.IS_RTL ? 'left' : 'right'
              }
            }}
            paragraph={false}
            active
          />
        </div>
      </div>
    </div>
  );
};

export const GamesSkeletonMobile = (): ReactElement => {
  return (
    <div>
      {Array.from({ length: 5 }, (v, i) => i).map(key => (
        <GameSingleItemSkeletonMobile key={key} expanded />
      ))}
    </div>
  );
};
